<template>
  <div class="h-screen w-screen p-4 flex flex-col bg-bg-end bg-cover">
    <div
      class="
        md:max-w-md md:self-center
        flex flex-col
        grow
        bg-white/80
        rounded-lg
        justify-around
      "
    >
      <div>
        <img
          class="w-24 h-24 rounded-full mx-auto m-2"
          src="@/assets/rida-min.jpeg"
        />
        <div class="px-4">
          <blockquote class="text-center">
            <h1 class="text-3xl text-center mb-4">Du vann!</h1>
            <p class="text-sm mt-4">
              Du har hjälpt Yennenga och visat kungen att det är möjligt att
              skapa förändring! Byn nådde de globala målen tack vare dig!
            </p>
          </blockquote>
          <button
            class="
              bg-green-500
              border-b-4 border-green-700
              hover:bg-green-600
              text-white
              font-bold
              mt-4
              py-2
              px-4
              rounded
              w-full
            "
            @click="redirectToGame()"
          >
            Spela igen
          </button>
        </div>
      </div>
      <div class="flex flex-col px-4">
        <p class="text-sm my-4">
          Vill du veta mer om FNs globala hållbarhetsmål?
        </p>
        <iframe
          class="overflow-hidden"
          src="https://www.youtube.com/embed/BzjSCMzTRNg"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import win from "../assets/sound/win.mp3";

export default {
  name: "End",
  data() {
    return {
      msg: "Slutsida",
      win: null,
    };
  },
  created() {
    this.winSound = new Audio(win);
  },
  mounted() {
    this.playWinSound();
  },
  methods: {
    redirectToGame() {
      this.$router.push("/spel");
    },
    playWinSound() {
      this.winSound.play();
    },
  },
};
</script>

<style></style>
